import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Fieldset} from "primereact/fieldset";
import DataTable from "../../shared/component/dataTable/DataTable";
import {Button, Col, Label, Row} from "reactstrap";
import Dialog from "../../shared/component/dialog/Dialog";
import OrderHistoryDetail from "./OrderHistoryDetail";
import OrdersHistoryColumn from "../../shared/component/dataTable/columns/OrdersHistoryColumn.json";
import OrdersHistoryMobileColumn from "../../shared/component/dataTable/columns/OrdersHistoryMobileColumn.json";

import GeneralUtils from "../../shared/utils/GeneralUtils";
import Translate from "../../shared/language/Translate";
import MerchantBranchCredentialsService from "../../shared/service/MerchantBranchCredentialsService";
import OrderService from "../../shared/service/OrderService";
import {Chart} from "primereact/chart";
import DateInput from "../../shared/component/form/DateInput";
import AvField from "../../shared/component/form/AvField";
import {DAYS_FILTER} from "../../shared/utils/Constants";

const defaultSummary = {
    cardPaySale: 0,
    cardPayCnt: 0,
    cashPaySale: 0,
    cashPayCnt: 0,
    applePaySale: 0,
    applePayCnt: 0,
    eatInSale: 0,
    eatInCnt: 0,
    deliverySale: 0,
    deliveryCnt: 0,
    collectionSale: 0,
    collectionCnt: 0,
    takeawaySale: 0,
    takeawayCnt: 0,
    totalSale: 0,
    tillTotalSale: 0,
    overDraftPaySale: 0,
    overDraftPayCnt: 0,
    accountPaySale: 0,
    accountPayCnt: 0
};

export default class OrderHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderNo: null,
            daysFilter: "Last 7 Days",
            startDate: GeneralUtils.getLast7DaysRange()[0].getTime(),
            endDate: GeneralUtils.getLast7DaysRange()[1].getTime(),
            clientList: [],
            summary: Object.assign(defaultSummary),
        };
        this.merchantBranchCredentialsService = new MerchantBranchCredentialsService();
        this.orderService = new OrderService();
    }

    componentDidMount() {
        this.merchantBranchCredentialsService.getClientTills(localStorage.getItem('merchantBranchId')).then(response => this.setState({
            clientList: response
        }));

        this.refreshDataTable();
        this.refreshSummary();
    }

    refreshDataTable = () => {
        this.refDataTable.refresh();
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false, orderNo: null});
    }

    render() {
        return (<div>
            <AvForm>
                {this.renderFilter()}
                {this.renderSummaryGraphics()}
                {this.completedOrderList()}
            </AvForm>
        </div>);
    }

    renderFilter() {
        return (<div>


            <Row>

                <Col md="2" className="mb-3">

                    <AvGroup>

                        <AvField
                            type="select"
                            className="form-control"
                            name="clientAgent"
                            value={this.state.clientAgent}
                            onChange={this.__handleChangeClientAgent}>
                            <option value="" key="">
                                ALL
                            </option>
                            {this.state.clientList.map(element => (
                                <option value={element.bssId} key={element.clientTillId}>
                                    {element.clientTillId}
                                </option>))}
                        </AvField>

                    </AvGroup>
                </Col>

                <Col md="2" className="mb-3">

                    <AvGroup>

                        <AvField
                            type="select"
                            className="form-control"
                            name="daysFilter"
                            value={this.state.daysFilter}
                            onChange={this.__handleChangeDaysFilter}>
                            {DAYS_FILTER.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>

                    </AvGroup>

                </Col>

                <Col md="2" className="mb-3">

                    <DateInput
                        name="startDate"
                        format={"DD/MM/YYYY"}
                        placeholder={"Start Date"}
                        onChange={this.__handleChangeStartDate}
                        disabled={this.state.daysFilter !== 'Custom'}
                        value={this.state.startDate}/>


                </Col>

                <Col md="2" className="mb-3">

                    <DateInput
                        name="endDate"
                        format={"DD/MM/YYYY"}
                        placeholder={"End Date"}
                        onChange={this.__handleChangeEndDate}
                        disabled={this.state.daysFilter !== 'Custom'}
                        value={this.state.endDate}/>


                </Col>


            </Row>
            <Row>
                <Col className="mb-3">
                    <Button color="outline-primary" style={{marginBottom: "10px", marginTop: "10px"}}
                            onClick={() => {
                                this.search();
                            }}>
                        <Translate contentKey="entity.action.add">Search</Translate>
                    </Button>
                </Col>

            </Row>
        </div>)
    }

    search() {
        this.refDataTable.dt.filter(this.state.clientAgent, "clientAgent", "equals");
        let filterElement = this.refDataTable.state.filterElement;
        this.refDataTable.setState({filterElement: filterElement});
        this.refDataTable.onModelFilterChangeWithNameAndValue("clientAgent", this.state.clientAgent, "string");
        this.refreshSummary();
    }

    completedOrderList() {
        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }
        return (<div>
            <Fieldset legend="Order History">

                <DataTable ref={(elem) => this.refDataTable = elem} fields={GeneralUtils.isMobile() ?  OrdersHistoryMobileColumn.fields: OrdersHistoryColumn.fields}
                           objectName={GeneralUtils.isMobile() ?  OrdersHistoryMobileColumn.name: OrdersHistoryColumn.name}
                           dataURL={"dispatchio/order/completedOrders/" + startDate + "/" + endDate}
                           rows={10}
                           emptyMessage="Not any order"
                           selectionMode="single" onDataSelect={this.onDataSelect}
                           loading={this.state.loading}/>


                <Dialog visible={this.state.displayDialog}
                        header={this.state.orderNo == null ? "Order Details" : this.state.orderNo}
                        onHide={() => this.setState({displayDialog: false})}
                        style={GeneralUtils.getDialogStyleMerchantForDialog()}>

                    <OrderHistoryDetail refreshDataTable={this.refreshDataTable}
                                        ref={(elem) => this.refModelSave = elem}
                                        closeDisplayDialog={this.closeDisplayDialog}/>
                </Dialog>
            </Fieldset>


        </div>)
    };

    __handleChangeStartDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({startDate: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeEndDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({endDate: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeClientAgent = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({clientAgent: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeDaysFilter = (e) => {
        const selectedFilter = e.target.value;
        let startDate = null;
        let endDate = null;

        switch (selectedFilter) {
            case 'Today':
                startDate = GeneralUtils.getStartOfToday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'This Week':
                startDate = GeneralUtils.getMonday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'Last Week':
                [startDate, endDate] = GeneralUtils.getLastWeekRange();
                break;
            case 'Last 7 Days':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            case 'This Month':
                [startDate, endDate] = GeneralUtils.getThisMonthRange();
                break;
            case 'Last Month':
                [startDate, endDate] = GeneralUtils.getLastMonthRange();
                break;
            case 'Custom':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            default:
                startDate = this.state.startDate ? new Date(this.state.startDate) : null;
                endDate = this.state.endDate ? new Date(this.state.endDate) : null;
                break;
        }

        this.setState({
            daysFilter: selectedFilter,
            startDate: startDate ? startDate.getTime() : null,
            endDate: endDate ? endDate.getTime() : null
        }, () => {
            this.search(); // This will run after state is updated
        });

    };

    onDataSelect = (data) => {
        this.refModelSave.setData(Object.assign({}, data));
        this.setState({
            displayDialog: true,
            orderNo: data.orderNo
        });

    }

    refreshSummary() {

        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }

        this.orderService.getSummary(startDate, endDate, clientAgent).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({summary: response});
            }

        });

    }

    renderSummaryGraphics() {

        const tillSaleList = this.state.summary.tillSalesList || [];

        const chartTillsData = {
            labels: tillSaleList.map(item => item.name + ' ' + GeneralUtils.formatGBP(item.amount) + ''),
            datasets: [
                {
                    label: 'Sales By Till',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: tillSaleList.map(item => parseFloat(item.amount)),
                }
            ]
        };

        const chartSalesData = {
            labels: ['Card ' + GeneralUtils.formatGBP(this.state.summary.cardPaySale), 'Cash ' + GeneralUtils.formatGBP(this.state.summary.cashPaySale)],
            datasets: [
                {
                    label: 'Sales By Payment',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#AB47BC'],
                    data: [this.state.summary.cardPaySale, this.state.summary.cashPaySale],
                }
            ]
        };


        const chartOrderTypeSalesData = {
            labels: ['Eat In ' + GeneralUtils.formatGBP(this.state.summary.eatInSale), 'Delivery ' + GeneralUtils.formatGBP(this.state.summary.deliverySale), 'Collection ' + GeneralUtils.formatGBP(this.state.summary.collectionSale), 'Takeaway ' + GeneralUtils.formatGBP(this.state.summary.takeawaySale)],
            datasets: [
                {
                    label: 'Sales By Order Type ',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#FFD54F'],
                    data: [this.state.summary.eatInSale, this.state.summary.deliverySale, this.state.summary.collectionSale, this.state.summary.takeawaySale],
                }
            ]
        };


        const chartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return (
            <div>
                <Fieldset legend={"Summary"}>


                    <Row className="justify-content-center">
                        <Col xs="12" md="4" className="mb-4">
                            <div className="chart-container">
                                <Chart type="bar" data={chartTillsData} options={chartOptions} height={"160px"} />
                                <div className="mt-2">
                                    <span>Total Sales: {GeneralUtils.formatGBP(this.state.summary.totalSale)}</span><br />
                                    <span>Till Sales: {GeneralUtils.formatGBP(this.state.summary.tillTotalSale)}</span>
                                </div>
                            </div>
                        </Col>
                        <Col xs="12" md="4" className="mb-4">
                            <div className="chart-container">
                                <Chart type="bar" data={chartSalesData} options={chartOptions} height={"160px"} />
                            </div>
                        </Col>
                        <Col xs="12" md="4" className="mb-4">
                            <div className="chart-container">
                                <Chart type="bar" data={chartOrderTypeSalesData} options={chartOptions} height={"160px"} />
                            </div>
                        </Col>
                    </Row>

                </Fieldset>
            </div>
        );
    }


}

